module.exports = __webpack_public_path__ + "img/barcode1.8ff14b76.png";